export const classes = {
  content: 'text-base md:text-lg text-grey-8 mb-2',
};
